//spanish
const messages = {
  'JAMES-TEST': "aqua"
};
module.exports = messages;
